import {qs, qsArray, trackEvent} from './utilities/index';

let Overlay = function () {
    if (Overlay.prototype._singletonInstance) {
        return Overlay.prototype._singletonInstance;
    }
    Overlay.prototype._singletonInstance = this;

    this.initialize();
}

Overlay.prototype.initialize = function () {

    let self = this;

    let importantOverlay = document.getElementById('important-overlay');
    let importantOverlayBg = qs('.overlay-bg', importantOverlay);
    let importantOverlayClose = qs('.close-button', importantOverlay);

    let anyModelOverlay = document.getElementById('any-model-overlay');
    let anyModelOverlayBg = qs('.overlay-bg', anyModelOverlay);
    let anyModelOverlayClose = qs('.close-button', anyModelOverlay);

    this.openImportantWindow = function (id) {
        importantOverlay.setAttribute('data-question-id', id);
        importantOverlay.classList.add('is-active');
        importantOverlay.clientHeight;
        importantOverlay.classList.add('is-visible');
        importantOverlayBg.addEventListener('click', this.closeImportantWindow);
        importantOverlayClose.addEventListener('click', this.closeImportantWindow);
    };

    this.closeImportantWindow = function () {
        importantOverlayBg.removeEventListener('click', this.closeImportantWindow);
        importantOverlayClose.removeEventListener('click', this.closeImportantWindow);
        importantOverlay.classList.remove('is-visible');
        setTimeout(function() {
            importantOverlay.classList.remove('is-active');
        }, 300);
    }

    this.openAnyBallWindow = function () {
      anyModelOverlay.classList.add('is-active');
      anyModelOverlay.clientHeight;
      anyModelOverlay.classList.add('is-visible');
      anyModelOverlayBg.addEventListener('click', this.closeAnyBallWindow);
      anyModelOverlayClose.addEventListener('click', this.closeAnyBallWindow);
    };

    this.closeAnyBallWindow = function () {
      anyModelOverlayBg.removeEventListener('click', this.closeAnyBallWindow);
      anyModelOverlayClose.removeEventListener('click', this.closeAnyBallWindow);
      anyModelOverlay.classList.remove('is-visible');
      setTimeout(function () {
        anyModelOverlay.classList.remove('is-active');
      }, 300);
    };

    // let whyOverlay = document.getElementById('why-overlay');
    // let whyOverlayBg = qs('.overlay-bg', whyOverlay);
    // let whyOverlayClose = qs('.close-button', whyOverlay);
    //
    // this.openWhyWindow = function (id) {
    //     whyOverlay.setAttribute('data-iron-id', id);
    //     whyOverlay.classList.add('is-active');
    //     whyOverlay.clientHeight;
    //     whyOverlay.classList.add('is-visible');
    //     whyOverlayBg.addEventListener('click', this.closeWhyWindow);
    //     whyOverlayClose.addEventListener('click', this.closeWhyWindow);
    // };
    //
    // this.closeWhyWindow = function () {
    //     whyOverlayBg.removeEventListener('click', this.closeWhyWindow);
    //     whyOverlayClose.removeEventListener('click', this.closeWhyWindow);
    //     whyOverlay.classList.remove('is-visible');
    //     setTimeout(function() {
    //         whyOverlay.classList.remove('is-active');
    //     }, 300);
    // }

    let mpiOverlay = document.getElementById('mpi-overlay');
    let mpiOverlayBg = qs('.overlay-bg', mpiOverlay);
    let mpiOverlayWrap = qs('.overlay-content-wrap', mpiOverlay);
    let mpiOverlayClose = qs('.close-button', mpiOverlay);
    let mpiOverlayValue = qs('.mpi-value', mpiOverlay);

    this.openMPIWindow = function (mpi, yCoord) {
        mpiOverlayValue.textContent = mpi;
        mpiOverlay.classList.add('is-active');
        mpiOverlay.clientHeight;
        mpiOverlay.classList.add('is-visible');
        mpiOverlayBg.addEventListener('click', this.closeMPIWindow);
        mpiOverlayClose.addEventListener('click', this.closeMPIWindow);
        window.scrollToMiddle();
        //mpiOverlayWrap.style.top = yCoord + 'px';
    };

    this.closeMPIWindow = function () {
        mpiOverlayBg.removeEventListener('click', this.closeMPIWindow);
        mpiOverlayClose.removeEventListener('click', this.closeMPIWindow);
        mpiOverlay.classList.remove('is-visible');
        setTimeout(function() {
            mpiOverlay.classList.remove('is-active');
        }, 300);
    }

    let mpiButtons = qsArray('.mpi-button');
    mpiButtons.forEach(function (btn) {
        let mpi = qs('.mpi-value', btn);
        btn.addEventListener('click', function(evt) {
            self.openMPIWindow(mpi.innerText, evt.clientY);
        });
    });

  let vidOverlay = document.getElementById('video-overlay');
  let vidOverlayContentWrap = qs('.overlay-content-wrap', vidOverlay);
  let vidOverlayContent = qs('.overlay-video-content', vidOverlay);
  let vidOverlayBg = qs('.overlay-bg', vidOverlay);
  let vidOverlayClose = qs('.close-button', vidOverlay);
  this.openVideoWindow = function (vidUrl, yCoord) {
    let iframe = document.createElement("iframe");
    let iframeUrl = vidUrl + '?rel=0&modestbranding=1&showinfo=0&controls=1&vq=hd720&enablejsapi=1';
    iframe.setAttribute("src", iframeUrl);

    iframe.setAttribute("frameborder", '0');
    iframe.setAttribute("allowfullscreen", '1');
      vidOverlayContent.appendChild(iframe);
      vidOverlay.classList.add('is-active');
      vidOverlay.classList.add('is-visible');
      vidOverlay.addEventListener('click', this.closeVideoWindow);
      vidOverlay.addEventListener('click', this.closeVideoWindow);
      //vidOverlayContentWrap.style.top = yCoord + 'px';
    const rect = vidOverlayContentWrap.getBoundingClientRect();
    window.scrollToMiddle();
    /*
      window.scrollTo({
        top: rect.top + window.scrollY,
        behavior: 'smooth'
      });*/
    };

  this.closeVideoWindow = function () {
    vidOverlayBg.removeEventListener('click', this.closeVideoWindow);
    vidOverlayClose.removeEventListener('click', this.closeVideoWindow);
    vidOverlayContent.innerHTML = "";
    vidOverlay.classList.remove('is-visible');
    setTimeout(function () {
      vidOverlay.classList.remove('is-active');
    }, 300);
  }


  let videoLinks = qsArray('.m-video a');
  videoLinks.forEach(function (lnk) {
    lnk.addEventListener('click', function (evt) {
      evt.preventDefault();
      
      var vidUrl = lnk.getAttribute('href');
      //console.log('open it ' + vidUrl);
      self.openVideoWindow(vidUrl, evt.clientY);
    });
  });


    // let attrOverlay = document.getElementById('attribute-overlay');
    // let attrOverlayBg = qs('.overlay-bg', attrOverlay);
    // let attrOverlayClose = qs('.close-button', attrOverlay);
    //
    // this.openAttrWindow = function (id) {
    //     attrOverlay.setAttribute('data-attribute-id', id);
    //     attrOverlay.classList.add('is-active');
    //     attrOverlay.clientHeight;
    //     attrOverlay.classList.add('is-visible');
    //     attrOverlayBg.addEventListener('click', this.closeAttrWindow);
    //     attrOverlayClose.addEventListener('click', this.closeAttrWindow);
    // };
    //
    // this.closeAttrWindow = function () {
    //     attrOverlayBg.removeEventListener('click', this.closeAttrWindow);
    //     attrOverlayClose.removeEventListener('click', this.closeAttrWindow);
    //     attrOverlay.classList.remove('is-visible');
    //     setTimeout(function() {
    //         attrOverlay.classList.remove('is-active');
    //     }, 300);
    // }
    //
    // let attrButtons = qsArray('.overlay-attribute-btn');
    // attrButtons.forEach(function (btn) {
    //     btn.addEventListener('click', function() {
    //         self.openAttrWindow(btn.getAttribute('data-attribute'));
    //     });
    // });

    let sendResultsOverlay = document.getElementById('send-results-overlay');
    let resultsOverlayBg = qs('.overlay-bg', sendResultsOverlay);
    let resultsOverlayClose = qsArray('.close-button', sendResultsOverlay);
    let resultsForm = qs('form', sendResultsOverlay);
    let emailInput = resultsForm.querySelector('input#email');
    let emailSuccess = sendResultsOverlay.querySelector('#success-email');
    let submitButton = resultsForm.querySelector('#submit');
    self.primaryId = '';
  self.alternateId = '';
  self.primaryColor = '';
  self.alternateColor = '';
    // let self = this;
    resultsForm.addEventListener('submit', function (e) {
        console.log('send results submitted ', emailInput.value);
      trackEvent('navigation', 'Send Results', 'Submit', emailInput.value);
      e.preventDefault();
        if (emailInput.value === '') {
            return;
        }
        window.submitResultsForm(emailInput.value, self.primaryId, self.primaryColor, self.alternateId, self.alternateColor);
        submitButton.disabled = true;
        submitButton.classList.add('disabled');
    }, true);

    this.showResultsError = function () {
        sendResultsOverlay.setAttribute('data-step-id', 'error');
    }

    this.setInitialEmailValue = function (email) {
        emailInput.value = email
    }

    this.showResultsSuccess = function () {
        emailSuccess.innerHTML = emailInput.value;
        sendResultsOverlay.setAttribute('data-step-id', 'success');
    }

    this.openSendResults = function (id, primaryId, primaryColor, alternateId, alternateColor) {
        console.log('Overlay.openSendResults ' + id + ', ' + primaryId + ', ' + alternateId);
        self.primaryId = primaryId;
        self.alternateId = alternateId;
        self.primaryColor = primaryColor;
        self.alternateColor = alternateColor;

        sendResultsOverlay.setAttribute('data-step-id', id);
        sendResultsOverlay.classList.add('is-active');
        sendResultsOverlay.clientHeight;
        sendResultsOverlay.classList.add('is-visible');
        submitButton.disabled = false;
        submitButton.classList.remove('disabled');
        resultsOverlayBg.addEventListener('click', this.closeSendResults);
        resultsOverlayClose.forEach(function(el) {
            el.addEventListener('click', self.closeSendResults);
        });
    }

    this.closeSendResults = function () {
        resultsOverlayBg.removeEventListener('click', this.closeSendResults);
        resultsOverlayClose.forEach(function(el){
            el.removeEventListener('click', self.closeSendResults);
        });
        sendResultsOverlay.classList.remove('is-visible');
        setTimeout(function() {
            sendResultsOverlay.classList.remove('is-active');
        }, 300);
    }
}

export default Overlay;
